/* eslint-disable react-hooks/rules-of-hooks */
import { FC, useMemo } from 'react';
import {
  Popup,
  TPopupComponent,
} from '../../../../../../../shared/components/popup/popup.abstract';
import { TPopupDefaultActions } from '../../../../../../../shared/components/popup/services/popup.service';
import { IBreakOffItem } from '../deliveryPeriods/components/rightSide/tabs/breakOff.popup';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { Content } from './content.popup';

export class AddOrEditBreakOff extends Popup<IAddOrEditBreakOff> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;

    this.Component = () => {
      const { t } = useTranslation();
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 594 },
          '& > div > div > div': { padding: 0 },
        }));
      }, []);

      return (
        <SWrapper stream={stream} popupTitle={t('article.break_off')}>
          <Content stream={stream} />
        </SWrapper>
      );
    };
  }
}

export interface IAddOrEditBreakOff {
  action: 'save' | TPopupDefaultActions;
  values: {
    breakOff?: IBreakOffItem;
    breakOffsData: IBreakOffItem[];
  };
}
